import { ref, readonly } from "vue";
import { getResizeImage } from "@/core/api/graphql/catalog";
import { Logger } from "@/core/utilities";
import type { InputAssetOperationCommandType, InputAssetOperationActionType } from "@/core/api/graphql/types";
import { assetOperations } from "@/core/api/graphql/files";

export function useAssetOperations() {
  const loading = ref(true);

  async function downloadAssets(params: InputAssetOperationActionType[]) {
    loading.value = true;
    try {
      const result = await assetOperations(params);

      return result;
    } catch (e) {
      Logger.error("useResizeImage.fetchRelatedProducts", e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return {
    downloadAssets,
    loading: readonly(loading),
  };
}
